import Alert from '@components/Alert'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { LessonCutOffProp } from './interface'
import WithUserTimeHOC, { WithUserTimeProps } from '@hocs/WithUserTime'
import { Wrapper } from './style'

const LessonCutOff: React.FC<LessonCutOffProp & WithUserTimeProps> = ({
  CurrentDate,
  loading,
  children,
  getDateWithUserTimezone,
}) => {
  const tzSelectedDate = getDateWithUserTimezone(CurrentDate.format())
  const isToday = getDateWithUserTimezone().isSame(tzSelectedDate, 'day')
  const isPastDate = getDateWithUserTimezone().isAfter(tzSelectedDate, 'day')
  const isTommorrow = getDateWithUserTimezone().add(1, 'day').isSame(tzSelectedDate, 'day')

  let isCutOff = false
  if (isTommorrow) {
    isCutOff = false
  } else if (isToday) {
    isCutOff = false
  } else if (isPastDate) {
    isCutOff = false
  } else {
    isCutOff = true
  }

  return (
    <>
      {isCutOff && !loading && (
        <Wrapper>
          <Alert alertType="warning" dismissable={false}>
            <FormattedMessage id="Note: This is a provisional schedule, until this is confirmed units might be added or removed." />
          </Alert>
        </Wrapper>
      )}

      {children(isCutOff)}
    </>
  )
}

export default WithUserTimeHOC(LessonCutOff)
